import script from "./commonUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./commonUpload.vue?vue&type=script&setup=true&lang=js"

import "./commonUpload.vue?vue&type=style&index=0&id=1ff545d4&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff545d4"]])

export default __exports__